export default {
    formatCurrency: function (amount) {
        return Number(amount).toLocaleString(undefined )
    },

}